// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 2107 ? "vendor.prosemirror-tables" : chunkId) + "." + {"2107":"b60cade0951bf7a9de2c","6980":"e38f5271bccfb8a7c163"}[chunkId] + ".js";
};